import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import "ant-design-pro/dist/ant-design-pro.css";
import "antd/dist/antd.css";
import * as serviceWorker from "./serviceWorker";

const render = Component => {
  ReactDOM.render(<Component />, document.getElementById("root"));
};

window.onload = () => {
  render(App);
};

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
